import { Button } from '@cdl/heartbeat-react';
import { Portal } from '../../../../shared/components/Portal';
import { useNavigationRef } from '../../hooks/useNavigationRef';

export const NavigateNextButton: React.FC = () => {
  const navigationRef = useNavigationRef();

  return (
    <Portal to={navigationRef}>
      <Button
        data-testid='next-btn'
        isDisabled={true}
        size='xs'
        borderRightRadius={0}
      >
        Next
      </Button>
    </Portal>
  );
};
